module.exports = __webpack_public_path__ + "greenland.svg?c02d7370c83475b43ccf210446cd74b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/greenland.svg
// module id = 177
// module chunks = 10